export const FT_BREAKFAST = 'b';
export const FT_SNACK = 's';
export const FT_LUNCH = 'l';
export const FT_DINER = 'd';
export const FT_OTHER = 'o';

export const foodTypes = [FT_BREAKFAST, FT_SNACK, FT_LUNCH, FT_DINER, FT_OTHER];
